export default __webpack_public_path__ + "static/media/whatsapp.0fd70f70.svg";